import bulkReturn1 from '../assets/BulkReturn1.png';
import bulkReturn2 from '../assets/BulkReturn2.png';
import bulkReturn3 from '../assets/BulkReturn3.png';
import bulkReturn4 from '../assets/BulkReturn4.png';
import bulkReturn5 from '../assets/BulkReturn5.png';
import bulkReturn6 from '../assets/BulkReturn6.png';
import createReturn1 from '../assets/CreateReturn1.png';
import createReturn2 from '../assets/CreateReturn2.png';
import createReturn3 from '../assets/CreateReturn3.png';
import createReturn4 from '../assets/CreateReturn4.png';
import createReturn5 from '../assets/CreateReturn5.png';
import createUser1 from '../assets/CreateUser1.png';
import creditMemo3 from '../assets/CreditMemo3.png';
import creditMemo1 from '../assets/CreditMemo4.png';
import creditMemo2 from '../assets/CreditMemoUI2.png';
import manageMultiUser2 from '../assets/ManageMultiUser2.png';
import returnReason1 from '../assets/ReturnReason1.png';
import returnTracking1 from '../assets/ReturnTracking1.png';
import returnTracking2 from '../assets/ReturnTracking2.png';
import { NewsArticle } from '../redux/types';

export const newsFeedImages = {
    creditMemo1: creditMemo1,
    creditMemo2: creditMemo2,
    creditMemo3: creditMemo3,
    createReturn1: createReturn1,
    createReturn2: createReturn2,
    createReturn3: createReturn3,
    createReturn4: createReturn4,
    createReturn5: createReturn5,
    bulkReturn1: bulkReturn1,
    bulkReturn2: bulkReturn2,
    bulkReturn3: bulkReturn3,
    bulkReturn4: bulkReturn4,
    bulkReturn5: bulkReturn5,
    bulkReturn6: bulkReturn6,
    createUser1: createUser1,
    manageMultiUser2: manageMultiUser2,
    returnReason1: returnReason1,
    returnTracking1: returnTracking1,
    returnTracking2: returnTracking2,
};

export const NEWS_ARTICLES: NewsArticle[] = [
    {
        startDate: 1661731200000,
        endDate: 1664496000000,
        articleDate: 1661904000000,
        articleTitleId: 'article1_title',
        articleTextIds: [{ textId: 'article1_summary' }],
        picturesByRow: [['creditMemo1', 'creditMemo2', 'creditMemo3']],
    },
    {
        startDate: 1690761600000, // 7-31-2023 00:00:00 UTC
        endDate: 1693785600000, // 9-4-2023 00:00:00 UTC
        articleDate: 1691107200000, // 8-4-2023 00:00:00 UTC
        articleTitleId: 'article2_title',
        articleTextIds: [{ textId: 'article2_summary' }],
        picturesByRow: [
            ['createReturn1', 'createReturn2', 'createReturn3'],
            ['createReturn4', 'createReturn5'],
        ],
    },
    {
        startDate: 1690761600000, // 7-31-2023 00:00:00 UTC
        endDate: 1693785600000, // 9-4-2023 00:00:00 UTC
        articleDate: 1691107200000, // 8-4-2023 00:00:00 UTC
        articleTitleId: 'article3_title',
        articleTextIds: [{ textId: 'article3_summary' }],
        picturesByRow: [
            ['bulkReturn1', 'bulkReturn2', 'bulkReturn3'],
            ['bulkReturn4', 'bulkReturn5', 'bulkReturn6'],
        ],
    },
    {
        startDate: 1692662400000, // 8-22-2023 00:00:00 UTC
        endDate: 1695859200000, // 9-28-2023 00:00:00 UTC
        articleDate: 1692662400000, // 8-22-2023 00:00:00 UTC
        articleTitleId: 'article4_title',
        articleTextIds: [{ textId: 'article4_summary' }],
        picturesByRow: [['createUser1']],
    },
    {
        startDate: 1692662400000, // 8-22-2023 00:00:00 UTC
        endDate: 1695859200000, // 9-28-2023 00:00:00 UTC
        articleDate: 1692662400000, // 8-22-2023 00:00:00 UTC
        articleTitleId: 'article5_title',
        articleTextIds: [{ textId: 'article5_summary' }],
        picturesByRow: [['manageMultiUser2']],
    },
    {
        startDate: 1762128000000, // 11-03-2025 00:00:00 UTC
        endDate: 1764720000000, // 12-03-2025 00:00:00 UTC
        articleDate: 1762128000000, // 11-03-2025 00:00:00 UTC
        articleTitleId: 'article7_title',
        articleTextIds: [{ textId: 'article7_summary' }],
        picturesByRow: [['returnReason1']],
    },
    {
        startDate: 1765240000000, // 2025-12-09 00:00:00 UTC
        endDate: 1768200000000, // 2026-01-12 00:00:00 UTC
        articleDate: 1765240000000, // 2025-12-09 00:00:00 UTC
        articleTitleId: 'article6_title',
        articleTextIds: [{ textId: 'article6_summary' }],
        picturesByRow: [['returnTracking1'], ['returnTracking2']],
        requiresReturnTracking: true,
    },
    {
        startDate: 1768435200000, // 2026-01-15 00:00:00 UTC
        endDate: 1771113600000, // 2026-02-15 00:00:00 UTC
        articleDate: 1768435200000, // 2026-01-15 00:00:00 UTC
        articleTitleId: 'article8_title',
        articleTextIds: [{ textId: 'article8_summary' }],
        picturesByRow: [],
    },
    {
        startDate: 1751241600000, // 2025-06-30 00:00:00 UTC
        endDate: 1753920000000, // 2025-07-31 00:00:00 UTC
        articleDate: 1751241600000, // 2025-06-30 00:00:00 UTC
        articleTitleId: 'article9_title',
        articleTextIds: [{ textId: 'article9_summary' }],
        picturesByRow: [],
    },
    {
        startDate: 1751241600000, // 2025-06-30 00:00:00 UTC
        endDate: 1753920000000, // 2025-07-31 00:00:00 UTC
        articleDate: 1751241600000, // 2025-06-30 00:00:00 UTC
        articleTitleId: 'article10_title',
        articleTextIds: [{ textId: 'article10_summary' }],
        picturesByRow: [],
    },
    {
        startDate: 1776384000000, // 2026-04-17 00:00:00 UTC
        endDate: 1778976000000, // 2026-05-17 00:00:00 UTC
        articleDate: 1776384000000, // 2026-04-17 00:00:00 UTC
        articleTitleId: 'article11_title',
        articleTextIds: [{ textId: 'article11_summary' }],
        picturesByRow: [],
    },
    {
        startDate: 1776384000000, // 2026-04-17 00:00:00 UTC
        endDate: 1778976000000, // 2026-05-17 00:00:00 UTC
        articleDate: 1776384000000, // 2026-04-17 00:00:00 UTC
        articleTitleId: 'article12_title',
        articleTextIds: [{ textId: 'article12_summary' }],
        picturesByRow: [],
    },
];
